<div class="not-found-wrapper">

  <div class="floating-shape shape--1"></div>
  <div class="floating-shape shape--2"></div>
  <div class="floating-shape shape--3"></div>

  <div class="not-found-content">

    <div class="not-found-code">
      <span>4</span><span class="digit--pulse">0</span><span>4</span>
    </div>

    <h4 class="not-found-title">Page not found</h4>
    <p class="not-found-text">
      The page you're looking for doesn't exist or may have been moved.
    </p>

    <!--
    <div class="quick-links">
      <a
        *ngFor="let link of quickLinks"
        [routerLink]="link.path"
        class="quick-link-card"
      >
        <div class="quick-link-icon">
          <ng-container [ngSwitch]="link.icon">

            <svg *ngSwitchCase="'map'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M9 20l-6-3V4l6 3 6-3 6 3v13l-6-3-6 3z"/>
              <path d="M9 4v13"/>
              <path d="M15 7v13"/>
            </svg>

            <svg *ngSwitchCase="'heart'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/>
            </svg>

            <svg *ngSwitchCase="'chart'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M3 3v18h18"/>
              <path d="M7 15l4-5 3 3 5-7"/>
            </svg>

          </ng-container>
        </div>

        <div class="quick-link-text">
          <span class="quick-link-label">{{ link.label }}</span>
          <span class="quick-link-desc">{{ link.description }}</span>
        </div>
      </a>
    </div>
    -->

    <div class="not-found-actions">
      <button class="btn btn-primary hover-animates" (click)="goHome()">
        <i class="bi bi-house-door"></i>
        Back to Home
      </button>

      <span class="redirect-note" *ngIf="!redirectCancelled">
        Redirecting in {{ redirectSeconds }}s ·
        <a href="javascript:void(0)" (click)="cancelRedirect()">cancel</a>
      </span>
    </div>

  </div>

</div>
